"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionsButtonWrapper = void 0;
var _mui = require("@ori-ui/mui");
const SubscriptionsButtonWrapper = exports.SubscriptionsButtonWrapper = (0, _mui.styled)('div')({
  width: '100%'
});